import React from 'react';
import {
  LuHome, LuPackage, LuShoppingCart, LuLineChart, LuFactory, LuLandmark, LuUsers,
  LuBarChart3, LuIndianRupee, LuReceipt, LuMegaphone, LuContact, LuWorkflow,
  LuFilePlus2, LuPackageCheck, LuTruck, LuClipboardList, LuFileText, LuPackageOpen,
  LuBadgeCheck, LuWallet, LuLayers, LuClipboardCheck, LuPackageMinus, LuCog, LuInfo,
  LuShieldCheck, LuKeyRound, LuRefreshCw, LuContainer, LuGem, LuStethoscope, LuStore,
  LuWrench, LuSparkles, LuSquare,
  // Point of Sale page
  LuScanLine, LuLayoutGrid, LuMonitorSmartphone, LuQrCode, LuPrinter, LuUndo2,
  LuPauseCircle, LuLock, LuUserCheck, LuPill, LuShirt, LuCoffee, LuHammer,
  LuShoppingBasket, LuToggleRight, LuCreditCard, LuSmartphone, LuCroissant,
  LuCakeSlice, LuSandwich, LuCookie, LuCupSoda, LuKeyboard, LuSearch,
  LuBanknote, LuWifiOff, LuFileSpreadsheet, LuTimer, LuArrowRight, LuMessageCircle,
  // Site navigation
  LuBookOpen, LuPlayCircle, LuHelpCircle, LuBuilding2, LuChevronDown,
  // Online Store, Project Management, Fleet pages
  LuGlobe, LuImage, LuShoppingBag, LuMail, LuPalette, LuPenLine, LuTag, LuClock, LuFuel, LuGauge, LuKanban, LuCalendarDays, LuTicket, LuLink, LuFileCheck, LuMapPin, LuListChecks, LuHeadphones, LuContact2, LuFileWarning, LuScale, LuBell, LuPaperclip, LuUpload, LuSend, LuCalculator, LuPieChart, LuFolderKanban,
} from 'react-icons/lu';

// Explicit kebab-name -> component map so bundlers tree-shake to only the
// icons the landing page actually uses (react-icons/lu ships 1200+).
export const ICONS = {
  'home': LuHome,
  'package': LuPackage,
  'shopping-cart': LuShoppingCart,
  'line-chart': LuLineChart,
  'factory': LuFactory,
  'landmark': LuLandmark,
  'users': LuUsers,
  'bar-chart-3': LuBarChart3,
  'indian-rupee': LuIndianRupee,
  'receipt-indian-rupee': LuReceipt,
  'megaphone': LuMegaphone,
  'contact-round': LuContact,
  'workflow': LuWorkflow,
  'file-plus-2': LuFilePlus2,
  'package-check': LuPackageCheck,
  'truck': LuTruck,
  'clipboard-list': LuClipboardList,
  'file-text': LuFileText,
  'package-open': LuPackageOpen,
  'badge-check': LuBadgeCheck,
  'wallet': LuWallet,
  'layers': LuLayers,
  'clipboard-check': LuClipboardCheck,
  'package-minus': LuPackageMinus,
  'cog': LuCog,
  'info': LuInfo,
  'shield-check': LuShieldCheck,
  'key-round': LuKeyRound,
  'refresh-cw': LuRefreshCw,
  'container': LuContainer,
  'gem': LuGem,
  'stethoscope': LuStethoscope,
  'store': LuStore,
  'wrench': LuWrench,
  'sparkles': LuSparkles,
  'scan-line': LuScanLine,
  'layout-grid': LuLayoutGrid,
  'monitor-smartphone': LuMonitorSmartphone,
  'qr-code': LuQrCode,
  'printer': LuPrinter,
  'undo-2': LuUndo2,
  'pause-circle': LuPauseCircle,
  'lock': LuLock,
  'user-check': LuUserCheck,
  'pill': LuPill,
  'shirt': LuShirt,
  'coffee': LuCoffee,
  'hammer': LuHammer,
  'shopping-basket': LuShoppingBasket,
  'toggle-right': LuToggleRight,
  'credit-card': LuCreditCard,
  'smartphone': LuSmartphone,
  'croissant': LuCroissant,
  'cake-slice': LuCakeSlice,
  'sandwich': LuSandwich,
  'cookie': LuCookie,
  'cup-soda': LuCupSoda,
  'keyboard': LuKeyboard,
  'search': LuSearch,
  'banknote': LuBanknote,
  'wifi-off': LuWifiOff,
  'file-spreadsheet': LuFileSpreadsheet,
  'timer': LuTimer,
  'arrow-right': LuArrowRight,
  'message-circle': LuMessageCircle,
  'book-open': LuBookOpen,
  'play-circle': LuPlayCircle,
  'help-circle': LuHelpCircle,
  'building-2': LuBuilding2,
  'chevron-down': LuChevronDown,
  'globe': LuGlobe,
  'image': LuImage,
  'shopping-bag': LuShoppingBag,
  'mail': LuMail,
  'palette': LuPalette,
  'pen-line': LuPenLine,
  'tag': LuTag,
  'clock': LuClock,
  'fuel': LuFuel,
  'gauge': LuGauge,
  'kanban': LuKanban,
  'calendar-days': LuCalendarDays,
  'ticket': LuTicket,
  'link': LuLink,
  'file-check': LuFileCheck,
  'map-pin': LuMapPin,
  'list-checks': LuListChecks,
  'headphones': LuHeadphones,
  'id-card': LuContact2,
  'file-warning': LuFileWarning,
  'scale': LuScale,
  'bell': LuBell,
  'paperclip': LuPaperclip,
  'upload': LuUpload,
  'send': LuSend,
  'calculator': LuCalculator,
  'pie-chart': LuPieChart,
  'folder-kanban': LuFolderKanban,
};

const Icon = ({ name, size = 16, className, style }) => {
  const Cmp = ICONS[name] || LuSquare;
  return <Cmp size={size} className={className} style={style} aria-hidden="true" />;
};

export default Icon;
